import { InnerTabs, MyBreadcrumb, MyButton, MyText, MyTextarea, OuterTabs, Print } from "../../components";
import { Card, Checkbox, Col, DatePicker, Form, Input, message, Modal, Radio, Row, Select, Table } from "antd";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { JOURNAL_TYPES, JOURNAL_TYPES_API, JOURNAL_YEAR } from "../../constants";
import { RootState } from "../../store";
import { selectStore } from "../../store/selector";
import { CheckOutlined, CloseOutlined, DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import {
  deletePrintRemark,
  deletePrintRemarkReset,
  editPrintRemark,
  editPrintStudy,
  getDisciplinesPrintTotalUvr, getFilteredGroups,
  getPrintMedical,
  getPrintMedicalGroup,
  getPrintModule,
  getPrintRemark,
  getPrintStudy,
  getPrintTotalUvr,
  getTeachersList,
  printCancelEdit,
  printJournal, printJournalParams,
  printJournalSubjectList,
  printMedicalEdit,
  printModuleEdit,
  printSetEdit,
  printStoreReset,
  setPrintRemark
} from "../../store/pages/printJournal/actions";
import dayjs from "dayjs";
import locale from 'antd/es/date-picker/locale/ru_RU';

const FORM_NAME = {
  TYPE_NUMBER: 'type_number',
  TYPE_STRING: 'type_string',
  YEAR: 'year',
  COURSE: 'course',
  GROUP: 'group',
  TEACHER: 'teacher_id'
}

const PRINT_TYPES = {
  MODULE: 'modules',
  STUDY: 'study',
  STUDENT_INDUSTRIAL: 'STUDENT_INDUSTRIAL',
  MEDICAL: 'medical',
  TOTAL_UVR: 'totalUvr',
  TOTAL_HALF: 'TOTAL_HALF',
  TOTAL_PO: 'TOTAL_PO',
  TOTAL_PP: 'TOTAL_PP',
  REMARK: 'remark',
  PRINT: 'PRINT',
}

const CHECKBOX_TYPES = {
  TITLE: 'title_page',
  CONTENT: 'content',
  MODULE: 'modules_info',
  GROUP: 'group_info',
  MEDICAL: 'medical_info',
  EDUCATION_WORK: 'educational_work_info',
  REMARKS: 'remarks_info',
  ATTENDANCE: 'attendance_performance_info',
}

const years = [
  {
    label: `${JOURNAL_YEAR.PREV}-${Number(JOURNAL_YEAR.PREV) + 1}`,
    year: JOURNAL_YEAR.PREV,
  },
  {
    label: `${JOURNAL_YEAR.CURRENT}-${Number(JOURNAL_YEAR.CURRENT) + 1}`,
    year: JOURNAL_YEAR.CURRENT,
  },
  {
    label: `${JOURNAL_YEAR.NEXT}-${Number(JOURNAL_YEAR.NEXT) + 1}`,
    year: JOURNAL_YEAR.NEXT,
  }
]

let sideInitialState = [
  {
    key: 'left',
    value: 'Левая'
  },
  {
    key: 'right',
    value: 'Правая'
  }
]

let currentFilterInitialState = {
  [FORM_NAME.YEAR]: null,
  [FORM_NAME.COURSE]: null,
  [FORM_NAME.GROUP]: null,
  [FORM_NAME.TEACHER]: null
}

const rules = [
  {
    required: true,
    message: 'Введите!',
  },
]

export const PrintJournal = () => {
  const { t } = useTranslation("common")
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [filterForm] = Form.useForm()
  const [remarkForm] = Form.useForm()

  const [type, setType] = useState<string>(JOURNAL_TYPES.THEORETICAL)

  const [editedObject, setEditedObject] = useState<any>({})

  const [totalUvr, setTotalUvr] = useState({
    side: sideInitialState[0],
    subject_id: null
  })

  const [currentSide, setCurrentSide] = useState<any>(sideInitialState[0])

  const {
    printJournal: {
      modules: modulesState,
      study: studyState,
      medical: medicalState,
      medicalGroups: medicalGroupsState,
      remark: remarkState,
      totalUvr: totalUvrState,
      totalUvrDisciplines: totalUvrDisciplinesState,
      groups: groupsState,
      teachersList: teachersListState,
      deletedRemark
    }
  }: RootState = useSelector(selectStore)


  useEffect(() => {
    if (deletedRemark.success) {
      onFinishFilter();
      dispatch(deletePrintRemarkReset())
    }
  }, [deletedRemark])

  const getGroups = (year: any, course: any) => {
    if (year && course) {
      dispatch(getFilteredGroups({
        year: year,
        course: course
      }))
    }
  }
  const getTeachers = (year: any) => {
    if (year) {
      dispatch(getTeachersList({
        year: year,
      }))
    }
  }
  const remarkDisable = () => {
    if (type === JOURNAL_TYPES.INDIVIDUAL) {
      return !filterForm.getFieldsValue()[FORM_NAME.TEACHER]
    }
    return !filterForm.getFieldsValue()[FORM_NAME.GROUP]
  }
  useEffect(() => {
    filterForm.setFields([{ name: FORM_NAME.YEAR, value: currentFilterInitialState[FORM_NAME.YEAR] }])
  }, [])

  const handleCancelState = (reduxState: any, index: any) => {
    let body = { reduxState, index }
    setEditedObject({})

    dispatch(printCancelEdit(body))
  }

  const handleEditState = (reduxState: any, index: any, object: any) => {
    let body = { reduxState, index, object }

    setEditedObject((prevState: any) => {
      return {
        reduxState: reduxState,
        object: {
          ...prevState?.object,
          ...object
        }
      }
    })

    if (object.isEdit) {
      dispatch(printSetEdit(body))
    }
  }

  const handleSaveState = (reduxState: any, index: any, object: any) => {
    let body = {}
    switch (reduxState) {
      case PRINT_TYPES.MODULE:
        body = {
          module_id: object.id,
          ...editedObject?.object
        }
        dispatch(printModuleEdit(body))
        break
      case PRINT_TYPES.STUDY:
        body = {
          ...object,
          ...editedObject?.object,
          side: currentSide.key,
          person_id: object.person_id
        }
        dispatch(editPrintStudy(body))
        break
      case PRINT_TYPES.MEDICAL:
        body = {
          person_id: object.person_id,
          medical_examination_date: editedObject?.object?.date,
          medical_note: editedObject?.object?.note,
          medical_group: editedObject?.object?.group?.name
        }
        dispatch(printMedicalEdit(body))
        break

      case PRINT_TYPES.TOTAL_UVR:
        break
      default:
        return false
    }
  }

  const handleRemark = (types: string, object: any) => {
    if (types === 'edit') {
      remarkForm.setFieldsValue({
        remark_text: object.remark_text,
        remark_date: dayjs(object.remark_date),
        remark_id: object.remark_id
      })
    }
    const handleClose = () => {
      modal.destroy()
      remarkForm.resetFields()
    }

    const handleOk = () => {
      const remark_date = remarkForm.getFieldsValue().remark_date
      const remark_text = remarkForm.getFieldsValue().remark_text
      const remark_id = remarkForm.getFieldsValue().remark_id

      const group_id = filterForm.getFieldsValue().group
      const teacher_id = filterForm.getFieldsValue().teacher_id
      let course = filterForm.getFieldsValue().course
      const year = filterForm.getFieldsValue().year

      let body = {}

      switch (types) {
        case 'add':
          body = {
            group_id: group_id,
            course: course,
            remark_date: dayjs(remark_date).format('YYYY-MM-DD'),
            remark_text: remark_text,
            teacher_id: teacher_id,
            group: group_id,
            year: year,
            ctp_type: JOURNAL_TYPES_API[type]
          }
          dispatch(setPrintRemark(body))
          break
        case 'delete':
          dispatch(deletePrintRemark(object.remark_id))
          break
        case 'edit':
          body = {
            remark_id: remark_id,
            remark_date: dayjs(remark_date).format('YYYY-MM-DD'),
            remark_text: remark_text,
          }
          dispatch(editPrintRemark(body))
          break

        default:
          return false
      }

      handleClose()
    }

    const content = (types === 'add' || types === 'edit') ? (
      <Row>
        <Col span={24}>
          <Form.Item name='remark_id' hidden />
        </Col>
        <Col span={24}>
          <Form.Item label='Дата' name='remark_date' labelCol={{
            span: 24
          }}>
            <DatePicker />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item label='Текст замечания или предложения' name='remark_text' labelCol={{
            span: 24
          }}>
            <MyTextarea />
          </Form.Item>
        </Col>
      </Row>
    ) : (
      <Row>
        <Col span={24}>
          <MyText>
            Вы уверены, что хотите удалить замечание?
          </MyText>
        </Col>
      </Row>
    )

    const modal = Modal.confirm({
      centered: true,
      icon: null,

      title: `${types === 'add' ? 'Добавить' : 'Редактировать'} замечание`,
      content: (
        <Form form={remarkForm} name='remarkForm' style={{ marginBottom: 24 }}>
          {content}
        </Form>
      ),
      footer: (
        <Row justify='center' gutter={16}>
          <Col>
            <MyButton title='Отмена' onClick={(close) => handleClose()} />
          </Col>
          <Col>
            <MyButton title={types === 'add' || types === 'edit' ? 'Сохранить' : 'Удалить'} type='primary'
              onClick={handleOk} />
          </Col>
        </Row>
      )
    })

    modal.update((prevConfig) => ({
      ...prevConfig
    }))
  }

  const handleSelectTotalUvrDiscipline = (item: any) => {
    setTotalUvr(prevState => ({
      ...prevState,
      subject_id: item.value
    }))

    let body = {
      ...filterForm.getFieldsValue(),
      subject_id: item.value,
      side: totalUvr.side.key
    }

    dispatch(getPrintTotalUvr(body))
  }

  const moduleColumn = [
    {
      title: '№ п/п',
      key: '№ п/п',
      dataIndex: 'index',
      render: (item: any, record: any, index: any) => {
        return index + 1
      },
    },
    {
      title: 'Наименование модуля',
      key: 'Наименование модуля',
      dataIndex: 'caption',
      render: (item: any, record: any, index: any) => {
        return item
      },
    },
    {
      title: 'Количество часов по учебному плану',
      key: 'Количество часов по учебному плану',
      dataIndex: 'total_hours',
      render: (item: any, record: any, index: any) => {
        return item
      },
    },
    {
      title: 'Дата начала',
      key: 'Дата начала',
      dataIndex: 'date_start',
      width: 150,
      render: (item: any, record: any, index: any) => {
        return (
          <Row>
            <Col span={24}>
              {record.isEdit ? <DatePicker  {...item ? { defaultValue: dayjs(item) } : {}}
                onChange={(date: any, dateString: any) => handleEditState(PRINT_TYPES.MODULE, index, {
                  date_start: dayjs(date).format('YYYY-MM-DD')
                })}
                format='DD.MM.YYYY' showToday={false} locale={locale} /> :
                <MyText>{item ? dayjs(item).format('DD.MM.YYYY') : ''}</MyText>}
            </Col>
          </Row>
        )
      },
    },
    {
      title: 'Дата завершения',
      key: 'Дата завершения',
      dataIndex: 'date_end',
      width: 150,
      render: (item: any, record: any, index: any) => {
        return (
          <Row>
            <Col span={24}>
              {record.isEdit ? <DatePicker  {...item ? { defaultValue: dayjs(item, 'DD.MM.YYYY') } : {}}
                onChange={(date: any, dateString: any) => handleEditState(PRINT_TYPES.MODULE, index, {
                  date_end: dayjs(date).format('YYYY-MM-DD')
                })}
                format='DD.MM.YYYY' showToday={false} locale={locale} /> :
                <MyText>{item ? dayjs(item).format('DD.MM.YYYY') : ''}</MyText>}
            </Col>
          </Row>
        )
      },
    },
    {
      title: 'Действие',
      key: 'Действие',
      dataIndex: 'action',
      width: 120,
      render: (item: any, record: any, index: any) => {
        return (
          <Row gutter={6} style={{ width: '100%' }} justify='center'>
            <Col>
              {
                record.isEdit ?
                  <MyButton icon={<CheckOutlined />} type='text' width={40} height={40} style={{ padding: 0 }}
                    onClick={() => handleSaveState(PRINT_TYPES.MODULE, index, record)} />
                  : <MyButton icon={<EditOutlined />} type='text' width={40} height={40} style={{ padding: 0 }}
                    onClick={() => handleEditState(PRINT_TYPES.MODULE, index, { isEdit: true })} />

              }
            </Col>
            {
              record.isEdit &&
              <Col>
                <MyButton icon={<CloseOutlined />} type='text' width={40} height={40} style={{ padding: 0 }}
                  onClick={() => handleCancelState(PRINT_TYPES.MODULE, index)} />
              </Col>
            }
          </Row>
        )
      },
    }
  ]

  const studyLeftColumn = [
    {
      title: '№ п/п',
      key: '№ п/п',
      dataIndex: 'index',
      render: (item: any, record: any, index: any) => {
        return index + 1
      },
    },
    {
      title: 'ФИО обучающегося',
      key: 'ФИО обучающегося',
      dataIndex: 'full_name',
      render: (item: any, record: any, index: any) => {
        return item
      },
    },
    {
      title: 'Число, месяц, год рождения',
      key: 'Число, месяц, год рождения',
      dataIndex: 'birth_date',
      render: (item: any, record: any, index: any) => {
        return (
          <Row>
            <Col span={24}>
              {record.isEdit ? <DatePicker  {...item ? { defaultValue: dayjs(item, 'YYYY-MM-DD') } : {}}
                onChange={(date: any, dateString: any) => handleEditState(PRINT_TYPES.STUDY, index, {
                  birth_date: dayjs(date).format('YYYY-MM-DD')
                })}
                format='DD.MM.YYYY' showToday={false} locale={locale} /> :
                <MyText>{item ? item : ''}</MyText>}
            </Col>
          </Row>
        )
      },
    },
    {
      title: 'Номер по поименной книге',
      key: 'Номер по поименной книге',
      dataIndex: 'name_book',
      width: 150,
      render: (item: any, record: any, index: any) => {
        return (
          <Row>
            <Col span={24}>
              {record.isEdit ? <Input {...item ? { defaultValue: item } : {}}
                onChange={(e) => handleEditState(PRINT_TYPES.STUDY, index, {
                  name_book: e.target.value
                })} /> :
                <MyText>{item ? item : ''}</MyText>}
            </Col>
          </Row>
        )
      },
    },
    {
      title: '№ приказа',
      key: '№ приказа',
      dataIndex: 'order_number',
      width: 150,
      render: (item: any, record: any, index: any) => {
        return (
          <Row>
            <Col>
              <MyText>{record.order_number}</MyText>
            </Col>
          </Row>
        )
      },
    },
    {
      title: 'Дата и № приказа о зачислении',
      key: 'Дата и № приказа о зачислении',
      dataIndex: 'order_date',
      width: 150,
      render: (item: any, record: any, index: any) => {
        return (
          <Row>
            <Col span={24}>
              {record.isEdit ? <DatePicker  {...item ? { defaultValue: dayjs(item, 'YYYY-MM-DD') } : {}}
                onChange={(date: any, dateString: any) => handleEditState(PRINT_TYPES.STUDY, index, {
                  order_date: dayjs(date).format('YYYY-MM-DD')
                })}
                format='DD.MM.YYYY' showToday={false} locale={locale} /> :
                <MyText>{item ? item : ''}</MyText>}
            </Col>
          </Row>
        )
      },
    },
    {
      title: 'Действие',
      key: 'Действие',
      dataIndex: 'action',
      width: 120,
      render: (item: any, record: any, index: any) => {
        return (
          <Row gutter={6} style={{ width: '100%' }} justify='center'>
            <Col>
              {
                record.isEdit ?
                  <MyButton icon={<CheckOutlined />} type='text' width={40} height={40} style={{ padding: 0 }}
                    onClick={() => handleSaveState(PRINT_TYPES.STUDY, index, record)} />
                  : <MyButton icon={<EditOutlined />} type='text' width={40} height={40} style={{ padding: 0 }}
                    onClick={() => handleEditState(PRINT_TYPES.STUDY, index, { isEdit: true })} />

              }
            </Col>
            {
              record.isEdit &&
              <Col>
                <MyButton icon={<CloseOutlined />} type='text' width={40} height={40} style={{ padding: 0 }}
                  onClick={() => handleCancelState(PRINT_TYPES.STUDY, index)} />
              </Col>
            }
          </Row>
        )
      },
    }
  ]

  const studyRightColumn = [
    {
      title: '№ п/п',
      key: '№ п/п',
      dataIndex: 'index',
      render: (item: any, record: any, index: any) => {
        return index + 1
      },
    },
    {
      title: 'ФИО обучающегося',
      key: 'ФИО обучающегося',
      dataIndex: 'caption',
      render: (item: any, record: any, index: any) => {
        return record.full_name
      },
    },
    {
      title: 'Домашний адрес обучающегося',
      key: 'Домашний адрес обучающегося',
      dataIndex: 'address',
      render: (item: any, record: any, index: any) => {
        return (
          <Row>
            <Col span={24}>
              {
                // record.isEdit ? <Input {...record.address ? { defaultValue: record.address } : {}}
                //   onChange={(e) => handleEditState(PRINT_TYPES.STUDY, index, {
                //     address: e.target.value
                //   })} /> :
                <MyText>{record.address ? record.address : ''}</MyText>}
            </Col>
          </Row>
        )
      },
    },
    {
      title: 'Телефон',
      key: 'Телефон',
      dataIndex: 'contacts',
      width: 150,
      render: (item: any, record: any, index: any) => {
        return (
          <Row>
            <Col span={24}>
              {
                // record.isEdit ? <Input {...record.contacts ? { defaultValue: record.contacts } : {}}
                //   onChange={(e) => handleEditState(PRINT_TYPES.STUDY, index, {
                //     contacts: e.target.value
                //   })} /> :
                <MyText>{record.contacts ? record.contacts : ''}</MyText>}
            </Col>
          </Row>
        )
      },
    },
    {
      title: 'Движение контингента',
      key: 'Движение контингента',
      dataIndex: 'contingent_movement',
      width: 150,
      render: (item: any, record: any, index: any) => {
        return (
          <Row>
            <Col span={24}>
              {record.isEdit ? <Input {...record.contingent_movement ? { defaultValue: record.contingent_movement } : {}}
                onChange={(e) => handleEditState(PRINT_TYPES.STUDY, index, {
                  contingent_movement: e.target.value
                })} /> :
                <MyText>{record.contingent_movement ? record.contingent_movement : ''}</MyText>}
            </Col>
          </Row>
        )
      },
    },
    {
      title: 'Дополнительные сведения',
      key: 'Дополнительные сведения',
      dataIndex: 'additional_info',
      width: 150,
      render: (item: any, record: any, index: any) => {
        return (
          <Row>
            <Col span={24}>
              {record.isEdit ? <Input {...record.additional_info ? { defaultValue: record.additional_info } : {}}
                onChange={(e) => handleEditState(PRINT_TYPES.STUDY, index, {
                  additional_info: e.target.value
                })} /> :
                <MyText>{record.additional_info ? record.additional_info : ''}</MyText>}
            </Col>
          </Row>
        )
      },
    },
    {
      title: 'Действие',
      key: 'Действие',
      dataIndex: 'action',
      width: 120,
      render: (item: any, record: any, index: any) => {
        return (
          <Row gutter={6} style={{ width: '100%' }} justify='center'>
            <Col>
              {
                record.isEdit ?
                  <MyButton icon={<CheckOutlined />} type='text' width={40} height={40} style={{ padding: 0 }}
                    onClick={() => handleSaveState(PRINT_TYPES.STUDY, index, record)} />
                  : <MyButton icon={<EditOutlined />} type='text' width={40} height={40} style={{ padding: 0 }}
                    onClick={() => handleEditState(PRINT_TYPES.STUDY, index, { isEdit: true })} />

              }
            </Col>
            {
              record.isEdit &&
              <Col>
                <MyButton icon={<CloseOutlined />} type='text' width={40} height={40} style={{ padding: 0 }}
                  onClick={() => handleCancelState(PRINT_TYPES.STUDY, index)} />
              </Col>
            }
          </Row>
        )
      },
    }
  ]

  const medicalColumn = [
    {
      title: '№ п/п',
      key: '№ п/п',
      dataIndex: 'index',
      render: (item: any, record: any, index: any) => {
        return index + 1
      },
    },
    {
      title: 'ФИО обучающегося',
      key: 'ФИО обучающегося',
      dataIndex: 'fio',
      render: (item: any, record: any, index: any) => {
        return record.full_name
      },
    },
    {
      title: 'Дата осмотра',
      key: 'Дата осмотра',
      dataIndex: 'date',
      width: 150,
      render: (item: any, record: any, index: any) => {
        return (
          <Row>
            <Col span={24}>
              {record.isEdit ?
                <DatePicker  {...record.medical_data.date ? { defaultValue: dayjs(record.medical_data.date, 'YYYY-MM-DD') } : {}}
                  onChange={(date: any, dateString: any) => handleEditState(PRINT_TYPES.MEDICAL, index, {
                    date: dayjs(date).format('YYYY-MM-DD')
                  })}
                  format='DD.MM.YYYY' showToday={false} locale={locale} /> :
                <MyText>{record.medical_data.date ? dayjs(record.medical_data.date).format('YYYY-MM-DD') : ''}</MyText>}
            </Col>
          </Row>
        )
      },
    },
    {
      title: 'Медгруппа (основная, подготовительная, специальная)',
      key: 'Медгруппа (основная, подготовительная, специальная)',
      dataIndex: 'group',
      width: 150,
      render: (item: any, record: any, index: any) => {
        return (
          <Row>
            <Col span={24}>
              {record.isEdit ?
                <Select
                  style={{ width: '100%' }} {...record.medical_data.group?.name ? { defaultValue: record.medical_data.group?.name } : {}}
                  options={medicalGroupsState.data.map((item: any) => ({
                    key: item.group_type,
                    label: item.caption,
                    value: item.group_type,
                    item: {
                      name: item.group_type,
                      caption: item.caption
                    }
                  }))} onChange={(value, option) => handleEditState(PRINT_TYPES.MEDICAL, index, {
                    // @ts-ignore
                    group: option?.item
                  })} /> :
                <MyText>{record?.medical_data?.group?.caption ? record?.medical_data?.group?.caption : ''}</MyText>}
            </Col>
          </Row>
        )
      },
    },
    {
      title: 'Примечание',
      key: 'Примечание',
      dataIndex: 'note',
      width: 150,
      render: (item: any, record: any, index: any) => {
        return (
          <Row>
            <Col span={24}>
              {record.isEdit ? <Input {...record.medical_data?.note ? { defaultValue: record.medical_data?.note } : {}}
                onChange={(e) => handleEditState(PRINT_TYPES.MEDICAL, index, {
                  note: e.target.value
                })} /> :
                <MyText>{record?.medical_data?.note ? record?.medical_data?.note : ''}</MyText>}
            </Col>
          </Row>
        )
      },
    },
  ]

  //todo доделать/ нихуя не понятно
  const totalUvrLeftColumn = [
    {
      title: '№ п/п',
      key: '№ п/п',
      dataIndex: 'index',
      render: (item: any, record: any, index: any) => {
        return index + 1
      },
    },
    {
      title: 'ФИО обучающегося',
      key: 'ФИО обучающегося',
      dataIndex: 'student_full_name',
      render: (item: any, record: any, index: any) => {
        return item
      },
    },
    {
      title: '1-е полугодие (семестр)',
      key: '1-е полугодие (семестр)',
      dataIndex: 'first_semester',
      width: 150,
      render: (item: any, record: any, index: any) => {
        return (
          <Row>
            <Col span={24}>
              {record.isEdit ? <Input {...record.first_semester ? { defaultValue: record.first_semester } : {}}
                onChange={(e) => handleEditState(PRINT_TYPES.TOTAL_UVR, index, {
                  first_semester: e.target.value
                })} /> :
                <MyText>{record.first_semester ? record.first_semester : ''}</MyText>}
            </Col>
          </Row>
        )
      },
    },
    {
      title: '2-е полугодие (семестр)',
      key: '2-е полугодие (семестр)',
      dataIndex: 'second_semester',
      width: 150,
      render: (item: any, record: any, index: any) => {
        return (
          <Row>
            <Col span={24}>
              {record.isEdit ? <Input {...record.second_semester ? { defaultValue: record.second_semester } : {}}
                onChange={(e) => handleEditState(PRINT_TYPES.TOTAL_UVR, index, {
                  second_semester: e.target.value
                })} /> :
                <MyText>{record.second_semester ? record.second_semester : ''}</MyText>}
            </Col>
          </Row>
        )
      },
    },
    {
      title: 'Рейтинг допуска к промежуточной и/или итоговой аттестации',
      key: 'Рейтинг допуска к промежуточной и/или итоговой аттестации',
      dataIndex: 'rating',
      width: 150,
      render: (item: any, record: any, index: any) => {
        return item
      },
    },
    {
      title: 'Зачет/Экзамен',
      key: 'Зачет/Экзамен',
      dataIndex: 'exam',
      width: 150,
      render: (item: any, record: any, index: any) => {
        return (
          <Row>
            <Col span={24}>
              {record.isEdit ? <Input {...record.exam ? { defaultValue: record.exam } : {}}
                onChange={(e) => handleEditState(PRINT_TYPES.TOTAL_UVR, index, {
                  exam: e.target.value
                })} /> :
                <MyText>{record.exam ? record.exam : ''}</MyText>}
            </Col>
          </Row>
        )
      },
    },
    {
      title: 'Итоговая оценка',
      key: 'Итоговая оценка',
      dataIndex: 'final',
      width: 150,
      render: (item: any, record: any, index: any) => {
        return (
          <Row>
            <Col span={24}>
              {record.isEdit ? <Input {...record.final ? { defaultValue: record.final } : {}}
                onChange={(e) => handleEditState(PRINT_TYPES.TOTAL_UVR, index, {
                  final: e.target.value
                })} /> :
                <MyText>{record.final ? record.final : ''}</MyText>}
            </Col>
          </Row>
        )
      },
    },
    // {
    //   title: 'Действие',
    //   key: 'Действие',
    //   dataIndex: 'action',
    //   width: 120,
    //   render: (item: any, record: any, index: any) => {
    //     return (
    //       <Row gutter={6} style={{width: '100%'}} justify='center'>
    //         <Col>
    //           {
    //             record.isEdit ?
    //               <MyButton icon={<CheckOutlined/>} type='text' width={40} height={40} style={{padding: 0}}
    //                         onClick={() => handleSaveState(PRINT_TYPES.TOTAL_UVR, index, record)}/>
    //               : <MyButton icon={<EditOutlined/>} type='text' width={40} height={40} style={{padding: 0}}
    //                           onClick={() => handleEditState(PRINT_TYPES.TOTAL_UVR, index, {isEdit: true})}/>
    //
    //           }
    //         </Col>
    //         {
    //           record.isEdit &&
    //           <Col>
    //             <MyButton icon={<CloseOutlined/>} type='text' width={40} height={40} style={{padding: 0}}
    //                       onClick={() => handleCancelState(PRINT_TYPES.TOTAL_UVR, index)}/>
    //           </Col>
    //         }
    //       </Row>
    //     )
    //   },
    // }
  ]

  //todo доделать/ нихуя не понятно
  const totalUvrRightColumn = [
    {
      title: '№ п/п',
      key: '№ п/п',
      dataIndex: 'index',
      render: (item: any, record: any, index: any) => {
        return index + 1
      },
    },
    {
      title: 'ФИО обучающегося',
      key: 'ФИО обучающегося',
      dataIndex: 'student_full_name',
      render: (item: any, record: any, index: any) => {
        return item
      },
    },
    {
      title: 'Пропущено часов',
      children: [
        {
          title: 'За полугодие (семестр)',
        },
        {
          title: 'В 1 полугодии (за 1-й семестр)',
          children: [
            {
              title: 'Всего',
              dataIndex: 'first_semester_total',
              render: (item: any, record: any, index: any) => {
                return record?.first_semester?.total
              },
            },
            {
              title: 'По не уважительной причине',
              dataIndex: 'first_semester_not_excused',
              render: (item: any, record: any, index: any) => {
                return record?.first_semester?.not_excused
              },
            }
          ]
        },
        {
          title: 'В 1 полугодии (за 2-й семестр)',
          children: [
            {
              title: 'Всего',
              dataIndex: 'second_semester_total',
              render: (item: any, record: any, index: any) => {
                return record?.second_semester?.total
              },
            },
            {
              title: 'По не уважительной причине',
              dataIndex: 'second_semester_not_excused',
              render: (item: any, record: any, index: any) => {
                return record?.second_semester?.not_excused
              },
            }
          ]
        },
        {
          title: 'За год',
          children: [
            {
              title: 'Всего',
              dataIndex: 'year_semester_total',
              render: (item: any, record: any, index: any) => {
                return record?.year?.total
              },
            },
            {
              title: 'По не уважительной причине',
              dataIndex: 'year_semester_not_excused',
              render: (item: any, record: any, index: any) => {
                return record?.year?.not_excused
              },
            }
          ]
        }
      ]
    },
    // {
    //   title: 'Действие',
    //   key: 'Действие',
    //   dataIndex: 'action',
    //   width: 120,
    //   render: (item: any, record: any, index: any) => {
    //     return (
    //       <Row gutter={6} style={{width: '100%'}} justify='center'>
    //         <Col>
    //           {
    //             record.isEdit ?
    //               <MyButton icon={<CheckOutlined/>} type='text' width={40} height={40} style={{padding: 0}}
    //                         onClick={() => handleSaveState(PRINT_TYPES.TOTAL_UVR, index, record)}/>
    //               : <MyButton icon={<EditOutlined/>} type='text' width={40} height={40} style={{padding: 0}}
    //                           onClick={() => handleEditState(PRINT_TYPES.TOTAL_UVR, index, {isEdit: true})}/>
    //
    //           }
    //         </Col>
    //         {
    //           record.isEdit &&
    //           <Col>
    //             <MyButton icon={<CloseOutlined/>} type='text' width={40} height={40} style={{padding: 0}}
    //                       onClick={() => handleCancelState(PRINT_TYPES.TOTAL_UVR, index)}/>
    //           </Col>
    //         }
    //       </Row>
    //     )
    //   },
    // }
  ]

  const remarkColumn = [
    {
      title: '№ п/п',
      key: '№ п/п',
      dataIndex: 'remark_id',
      render: (item: any, record: any, index: any) => {
        return item
      },
    },
    {
      title: 'Дата',
      key: 'Дата',
      dataIndex: 'remark_date',
      render: (item: any, record: any, index: any) => {
        return (
          <Row>
            {record.isEdit ? <DatePicker  {...item ? { defaultValue: dayjs(item, 'YYYY-MM-DD') } : {}}
              onChange={(date: any, dateString: any) => handleEditState(PRINT_TYPES.REMARK, index, {
                remark_date: dayjs(date).format('YYYY-MM-DD')
              })}
              format='YYYY-MM-DD' showToday={false} locale={locale} /> :
              <MyText>{item ? dayjs(item).format('YYYY-MM-DD') : ''}</MyText>}
          </Row>
        )
      },
    },
    {
      title: 'Содержание замечаний и предложений',
      key: 'Содержание замечаний и предложений',
      dataIndex: 'remark_text',
      render: (item: any, record: any, index: any) => {
        return (
          <Row>
            {record.isEdit ? <Input {...item ? { defaultValue: item } : {}}
              onChange={(e) => handleEditState(PRINT_TYPES.REMARK, index, {
                remark_text: e.target.value
              })} /> :
              <MyText>{item ? item : ''}</MyText>}
          </Row>
        )
      },
    },
    {
      title: 'Фамилия и инициалы проверившего журнал, должность и подпись',
      key: 'Фамилия и инициалы проверившего журнал, должность и подпись',
      dataIndex: 'inspector',
      render: (item: any, record: any, index: any) => {
        return item
      },
    },
    {
      title: 'Действие',
      key: 'Действие',
      dataIndex: 'action',
      width: 120,
      render: (item: any, record: any, index: any) => {
        return (
          <Row gutter={6} style={{ width: '100%' }} justify='center'>
            <Col>
              <MyButton icon={<EditOutlined />} type='text' width={40} height={40} style={{ padding: 0 }}
                onClick={() => handleRemark('edit', record)} />
            </Col>
            <Col>
              <MyButton icon={<DeleteOutlined />} type='text' width={40} height={40} style={{ padding: 0 }}
                onClick={() => handleRemark('delete', record)} />
            </Col>
          </Row>
        )
      },
    }
  ]

  const onFinishFilter = () => {
    filterForm.validateFields().then((values) => {
      let url = {
        [JOURNAL_TYPES.THEORETICAL]: 'theoretic',
        [JOURNAL_TYPES.INDUSTRIAL]: 'industrial',
        [JOURNAL_TYPES.TEACHERS_PRACTICE]: 'industrial-accounting',
        [JOURNAL_TYPES.INDIVIDUAL]: 'individual'
      }

      switch (type) {
        case JOURNAL_TYPES.THEORETICAL:
          dispatch(getPrintModule(values))
          dispatch(getPrintStudy({ ...values, side: currentSide.key }))
          dispatch(getPrintMedical(values))
          dispatch(getPrintMedicalGroup(values))
          dispatch(getPrintRemark({ ...values, ctp_type: JOURNAL_TYPES_API[type] }))
          dispatch(getDisciplinesPrintTotalUvr(values))
          dispatch(printJournalParams({ body: {}, url: url[type] }))
          dispatch(printJournalSubjectList({ body: values, url: url[type] }))
          break
        case JOURNAL_TYPES.INDUSTRIAL:
          dispatch(getPrintRemark({ ...values, ctp_type: JOURNAL_TYPES_API[type] }))
          dispatch(printJournalParams({ body: {}, url: url[type] }))
          dispatch(printJournalSubjectList({ body: values, url: url[type] }))
          break
        case JOURNAL_TYPES.TEACHERS_PRACTICE:
          dispatch(getPrintRemark({ ...values, ctp_type: JOURNAL_TYPES_API[type] }))
          dispatch(printJournalParams({ body: {}, url: url[type] }))
          dispatch(printJournalSubjectList({ body: values, url: url[type] }))
          break
        case JOURNAL_TYPES.INDIVIDUAL:
          dispatch(getPrintRemark({ ...values, ctp_type: JOURNAL_TYPES_API[type] }))
          dispatch(printJournalParams({ body: {}, url: url[type] }))
          dispatch(printJournalSubjectList({ body: values, url: url[type] }))
          break
        default:
          break
      }

    }).catch(() => {
      message.error(t("error"))
    })
    return;
  }

  const onValuesChangeFilter = (changedFields: any, allFields: any) => {
    const key = Object.keys(changedFields)[0]
    const value = Object.values(changedFields)[0]
    switch (key) {
      case FORM_NAME.YEAR:
        getTeachers(value)
        getGroups(value, filterForm.getFieldsValue()[FORM_NAME.COURSE])
        filterForm.resetFields([FORM_NAME.GROUP])
        break

      case FORM_NAME.COURSE:
        getGroups(filterForm.getFieldsValue()[FORM_NAME.YEAR], value)
        filterForm.resetFields([FORM_NAME.GROUP])
        break

      case FORM_NAME.GROUP:
        break
      case FORM_NAME.TEACHER:
        break
      default:
        return false
    }
  }

  const moduleRender = () => {
    return (
      <Row gutter={[32, 32]}>
        <Col span={24}>
          <MyText size={24} weight={700} color='var(--c-title-text)'>
            Сведения о реализуемых модулях на учебный год
          </MyText>
        </Col>

        <Col span={24}>
          <Table columns={moduleColumn} dataSource={modulesState.data} loading={modulesState.loading}
            rowKey={(record) => record.id} pagination={false} />
        </Col>
      </Row>
    )
  }

  const studentJournalRender = () => {
    return (
      <Row gutter={[32, 32]}>
        <Col span={24}>
          <Row justify='space-between' align='middle'>
            <Col>
              <MyText size={24} weight={700} color='var(--c-title-text)'>
                Сведения об обучающихся группы
              </MyText>
            </Col>

            <Col>
              <Radio.Group defaultValue={currentSide.key} size="large" onChange={(e) => {
                let res = sideInitialState.find(item => item.key === e.target.value)
                setCurrentSide(res)
                setEditedObject({})
                let filter = filterForm.getFieldsValue()
                if (filter.group) {
                  dispatch(getPrintStudy({ ...filterForm.getFieldsValue(), side: res?.key }))
                }
              }}>
                {
                  sideInitialState.map(item => (
                    <Radio.Button value={item.key} key={item.key}>{item.value}</Radio.Button>
                  ))
                }
              </Radio.Group>
            </Col>
          </Row>
        </Col>

        <Col span={24}>
          <Table columns={currentSide.key === 'left' ? studyLeftColumn : studyRightColumn} dataSource={studyState.data}
            loading={studyState.loading}
            rowKey={(record) => record.person_id} pagination={false} />
        </Col>
      </Row>
    )
  }

  const medicalRender = () => {
    return (
      <Row gutter={[32, 32]}>
        <Col span={24}>
          <MyText size={24} weight={700} color='var(--c-title-text)'>
            Результаты медицинского осмотра обучающихся
          </MyText>
        </Col>

        <Col span={24}>
          <Table columns={medicalColumn} dataSource={medicalState.data} loading={medicalState.loading}
            rowKey={(record) => record.person_id} pagination={false} />
        </Col>
      </Row>
    )
  }

  const totalUvrRender = () => {
    return (
      <Row gutter={[32, 32]}>
        <Col span={24}>
          <Row justify='space-between' align='middle'>
            <Col>
              <MyText size={24} weight={700} color='var(--c-title-text)'>
                Итоги учебно-воспитательной работы
              </MyText>
            </Col>

            <Col>
              <Select placeholder='Выберите дисциплину из списка'
                options={totalUvrDisciplinesState.data?.map((item: any, index: any) => ({
                  key: `discipline-${item.id}-${index}`,
                  label: item.caption,
                  value: item.id,
                  item: item
                }))} onChange={(value, option) => handleSelectTotalUvrDiscipline(option)} />
            </Col>

            <Col>
              <Radio.Group defaultValue={totalUvr.side.key} size="large" onChange={(e) => {
                let res = sideInitialState.find(item => item.key === e.target.value)
                // @ts-ignore
                setTotalUvr(prevState => ({
                  ...prevState,
                  side: res
                }))
                setEditedObject({})
                let filter = filterForm.getFieldsValue()
                if (filter.group && totalUvr.subject_id) {
                  dispatch(getPrintTotalUvr({
                    ...filterForm.getFieldsValue(),
                    side: res?.key,
                    subject_id: totalUvr.subject_id
                  }))
                }
              }}>
                {
                  sideInitialState.map(item => (
                    <Radio.Button value={item.key} key={item.key}>{item.value}</Radio.Button>
                  ))
                }
              </Radio.Group>
            </Col>
          </Row>
        </Col>

        <Col span={24}>
          <Table columns={totalUvr?.side?.key === 'left' ? totalUvrLeftColumn : totalUvrRightColumn}
            dataSource={totalUvrState.data}
            loading={totalUvrState.loading}
            rowKey={record => record.student_id} pagination={false} />
        </Col>
      </Row>
    )
  }

  const remarkRender = () => {
    return (
      <Row gutter={[32, 32]}>
        <Col span={24}>
          <Row justify='space-between'>
            <Col>
              <MyText size={24} weight={700} color='var(--c-title-text)'>
                Замечания и предложения по ведению журнала
              </MyText>
            </Col>
            <Col>
              <MyButton type='primary' ghost title='Добавить замечание' icon={<PlusOutlined />}
                onClick={() => handleRemark('add', {})} disabled={remarkDisable()} />
            </Col>
          </Row>
        </Col>

        <Col span={24}>
          <Table columns={remarkColumn} dataSource={remarkState.data} loading={remarkState.loading}
            rowKey={record => record.remark_id} pagination={false} />
        </Col>
      </Row>
    )
  }

  const totalHalfRender = () => {
    return (
      <h1>qwe</h1>
    )
  }

  const totalPoRender = () => {
    return (
      <h1>qwe</h1>
    )
  }

  const totalPpRender = () => {
    return (
      <h1>qwe</h1>
    )
  }

  const innerTheoreticalItems = [
    {
      key: PRINT_TYPES.MODULE,
      label: t('printModule'),
      children: (
        <Card>
          {moduleRender()}
        </Card>
      )
    },
    {
      key: PRINT_TYPES.STUDY,
      label: t('printStudent'),
      children: (
        <Card>
          {studentJournalRender()}
        </Card>
      )
    },
    {
      key: PRINT_TYPES.MEDICAL,
      label: t('printMedical'),
      children: (
        <Card>
          {medicalRender()}
        </Card>
      )
    },
    {
      key: PRINT_TYPES.TOTAL_UVR,
      label: t('printTotalUvr'),
      children: (
        <Card>
          {totalUvrRender()}
        </Card>
      )
    },
    {
      key: PRINT_TYPES.REMARK,
      label: t('printRemark'),
      children: (
        <Card>
          {remarkRender()}
        </Card>
      )
    },
    {
      key: PRINT_TYPES.PRINT,
      label: t('printJournal'),
      children: (
        <Card>
          <Print filterForm={filterForm} type={type} />
        </Card>
      )
    },
  ]

  const innerTeacherItems = [
    {
      key: PRINT_TYPES.REMARK,
      label: t('printRemark'),
      children: (
        <Card>
          {remarkRender()}
        </Card>
      )
    },
    {
      key: PRINT_TYPES.PRINT,
      label: t('printJournal'),
      children: (
        <Card>
          <Print filterForm={filterForm} type={type} />
        </Card>
      )
    },
  ]
  const innerIndustrialItems = [
    {
      key: PRINT_TYPES.REMARK,
      label: t('printRemark'),
      children: (
        <Card>
          {remarkRender()}
        </Card>
      )
    },
    {
      key: PRINT_TYPES.PRINT,
      label: t('printJournal'),
      children: (
        <Card>
          <Print filterForm={filterForm} type={type} />
        </Card>
      )
    },
  ]

  const handleClickInnerTab = (key: any) => {
    setEditedObject({})
  }

  const handleClickOuterTab = (key: any) => {
    setType(key)
    if (JOURNAL_TYPES.INDIVIDUAL === key) {
      filterForm.resetFields([FORM_NAME.TEACHER])
      filterForm.resetFields([FORM_NAME.COURSE])
      getTeachers(filterForm.getFieldsValue()[FORM_NAME.YEAR]);
    } else {
      getGroups(filterForm.getFieldsValue()[FORM_NAME.YEAR], filterForm.getFieldsValue()[FORM_NAME.COURSE])
      filterForm.resetFields([FORM_NAME.GROUP])
    }
    dispatch(printStoreReset())
    setEditedObject({})
  }

  const filterFormContent = useMemo(() => (
    <Col span={24}>
      <Card>
        <Form form={filterForm}
          layout="vertical"
          onFinish={onFinishFilter}
          onValuesChange={(changedFields, allFields) => onValuesChangeFilter(changedFields, allFields)}
          onReset={() => {
            filterForm.resetFields()
          }}
        >
          <Row align='bottom' gutter={[16, 16]} justify='space-between'>
            <Col span={type == JOURNAL_TYPES.INDIVIDUAL ? 9 : 6}>
              <Form.Item label={t('studyYear')} name={[FORM_NAME.YEAR]} rules={rules}>
                <Select>
                  {
                    years.map(item => (
                      <Select.Option key={item.year} value={item.year}>
                        {item.label}
                      </Select.Option>
                    ))
                  }
                </Select>
              </Form.Item>
            </Col>
            {
              type == JOURNAL_TYPES.INDIVIDUAL ?
                <Col span={9}>
                  <Form.Item label={t('teacher')} name={[FORM_NAME.TEACHER]} rules={rules}>
                    {
                      <Select loading={teachersListState.loading} showSearch
                        filterOption={(input: any, option: any) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                      >
                        {
                          teachersListState?.data?.map((item: any) => (
                            <Select.Option key={item.value} value={item.value}>
                              {item.label}
                            </Select.Option>
                          ))
                        }
                      </Select>
                    }
                  </Form.Item>
                </Col>
                :
                <>
                  <Col span={6}>
                    <Form.Item label={t('course')} name={[FORM_NAME.COURSE]} rules={rules}>
                      <Select>
                        {
                          [1, 2, 3, 4].map(item => (
                            <Select.Option key={item} value={item}>
                              {item}
                            </Select.Option>
                          ))
                        }
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label={t('group')} name={[FORM_NAME.GROUP]} rules={rules}>
                      <Select loading={groupsState.loading} showSearch
                        filterOption={(input: any, option: any) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                        {
                          groupsState?.data?.map((item: any) => (
                            <Select.Option key={item.id} value={item.id}>
                              {item.caption}
                            </Select.Option>
                          ))
                        }
                      </Select>
                    </Form.Item>
                  </Col>
                </>
            }

            <Row style={{ gap: 8 }}>
              <Form.Item>
                <MyButton title={t('throw')} htmlType='reset' width='100%' />
              </Form.Item>
              <Form.Item>
                <MyButton title={t('set')} htmlType='submit' width='100%' />
              </Form.Item>
            </Row>
          </Row>
        </Form>
      </Card>
    </Col>
  ), [groupsState, teachersListState, type])

  const outerItems = [
    {
      key: JOURNAL_TYPES.THEORETICAL,
      label: t('journalTheoretical'),
      children: (
        <Row>
          {filterFormContent}
          <Col span={24}>
            <InnerTabs items={innerTheoreticalItems} defaultActiveKey={PRINT_TYPES.MODULE}
              onTabClick={(key: any) => handleClickInnerTab(key)} />
          </Col>
        </Row>
      ),
    },
    {
      key: JOURNAL_TYPES.INDUSTRIAL,
      label: t('journalIndustrial'),
      children: (
        <Row>
          {filterFormContent}
          <Col span={24}>
            <InnerTabs items={innerIndustrialItems} defaultActiveKey={PRINT_TYPES.MODULE}
              onTabClick={(key: any) => handleClickInnerTab(key)} />
          </Col>
        </Row>
      ),
    },
    {
      key: JOURNAL_TYPES.TEACHERS_PRACTICE,
      label: t('teachersPractice'),
      children: (
        <Row>
          {filterFormContent}
          <Col span={24}>
            <InnerTabs items={innerTeacherItems} defaultActiveKey={PRINT_TYPES.MODULE}
              onTabClick={(key: any) => handleClickInnerTab(key)} />
          </Col>
        </Row>
      ),
    },
    {
      key: JOURNAL_TYPES.INDIVIDUAL,
      label: t('individualJournal'),
      children: (
        <Row>
          {filterFormContent}
          <Col span={24}>
            <InnerTabs items={innerTeacherItems} defaultActiveKey={PRINT_TYPES.MODULE}
              onTabClick={(key: any) => handleClickInnerTab(key)} />
          </Col>
        </Row>
      ),
    }
  ]

  return (
    <>
      <MyBreadcrumb title={t('printJournal')} />

      <Row justify='center'>
        <Col span={20}>
          <Row>
            <Col span={24}>
              <OuterTabs items={outerItems} onChange={(key) => handleClickOuterTab(key)} activeKey={type} />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  )
}
